export default __webpack_public_path__ + "static/media/ipad-table.86938250.jpg";